// Custom JS variables
// Note: must be in global scope and not nested within an object
let chatDept = null;
let prechatVehicle = null;
let orderNumber = null;

// Object-scoped prechat form JS
const chatJs = {
    $body : $('body'),
    $renderTarget : ( $('.bs4').length ) ? $('body > .bs4').first() : $('body'),
    $chatLinks : $('.js-begin-chat'),
    status : {
        state: 'loading',
        icon: 'envelope',
        labelText: 'Email',
    },
    formFields : {},
    activeWidget : snapEngageWidgets.find( widget => {
        return widget.id == sessionStorage.getItem('SEactiveWidgetID');
    }),
    userData : {},
    chatOpen : false,
    vehicleSelector : null,

    getUserData : () => {
        return $.ajax({
            url: chatURLs.userLookup,
            type: 'GET',
            success: result => {
                chatJs.userData = result;
                if ( selectedVehicle ) prechatVehicle = selectedVehicle;
            },
            error: err => {
                throw(err);
            } 
        });
    },

    // send user data to SnapEngage
    setSEUserData : data => {
        SnapEngage.setUserEmail( data.userEmail );
        SnapEngage.setUserName( data.userName );
    },

    setVehicleData : vehicleConfigID => {
        let vehicleString = chatJs.vehicleSelector.getSelectedOptionsString();
        const newVehicle = vehicleString.trim();
        if ( chatJs.$selectedVehicle ) {
            chatJs.$selectedVehicle.val(newVehicle);
        }
        prechatVehicle = newVehicle;
    },

    // manage flags for online/offline status on chat links
    setChatStatus : ( online = false ) => {
        if ( online ) {
            chatJs.status.state = 'online';
            chatJs.status.icon = 'comments';
            chatJs.status.labelText = 'Chat with';
        } else {
            chatJs.status.state = 'offline';
        }
        chatJs.$chatLinks.addClass(chatJs.status.state);
    },

    // enable/disable 'Start Chatting' button in modal based on form validation
    setChatBtnState : isValid => {
        chatJs.$startChatBtn.prop('disabled', !isValid);
        chatJs.$startChatBtn.attr('title', (isValid) ? 'Click here to start chatting with us' : 'Please fill out the required info');
    },

    minimizedChatActive : () => {
        const cookiesArray = document.cookie.split(';');
        let SEcookie = false;
        cookiesArray.some( cookie => {
            if (cookie.indexOf('SnapABugChatWindow') !== -1 && cookie.indexOf('true') !== -1) SEcookie = true;
        });
        return SEcookie;
    },

    widgetName : value => {
        chatDept = value.charAt(0).toUpperCase() + value.slice(1);
    },

    validateInput : ( $input, bypassStyles ) => {
        const $errorMsg = $input.next('.js-error-msg');
        const $val = $input.val();
        let pattern = $input.data('pattern');
        let isValid = false;
        let errorMsg;
        if (!$val.length) {
            errorMsg = 'Please fill out this field.';
        } else {
            if (!pattern) {
                switch ($input.attr('type')) {
                    case 'email':
                        pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        isValid = pattern.test($val);
                        if (!isValid) errorMsg = 'Please enter a valid email address.';
                        break;
                    case 'tel':
                        pattern = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
                        isValid = pattern.test($val);
                        if (!isValid) errorMsg = 'Please enter a valid phone number.';
                        break;
                    default:
                        isValid = Boolean($val);
                }
            } else {
                isValid = pattern.test($val);
            }
        }
        if (!bypassStyles) {
            if (isValid) {
                $input.removeClass('error');
                $input.addClass('valid');
                $errorMsg.hide();
            } else {
                $input.removeClass('valid');
                $input.addClass('error');
                $errorMsg.html(errorMsg);
                $errorMsg.show();
            }
        }
        chatJs.updateFieldValidState( $input.attr('name'), isValid );
        return isValid;
    },

    validateForm : () => {
        let isValid = true;
        // Check chatJs.formFields for 'false' values
        for ( const field in chatJs.formFields ) {
            if (!chatJs.formFields[field]) {
                isValid = false;
                break;
            }
        }
        chatJs.setChatBtnState(isValid);
    },

    resetMoreInfo : data => {
        let elementArray = [];
        chatJs.$moreInfo.html('');
        switch ( data ) {
            case 'testing 1':
                elementArray.push('orderNumber');
                elementArray.push('orderReturn');
                elementArray.push('selectedVehicle');
                elementArray.push('changeVehicle');
                elementArray.push('vehicleSelector');
                break;
            case 'testing 2':
                elementArray.push('orderNumber');
                elementArray.push('orderReturn');
                elementArray.push('selectedVehicle');
                elementArray.push('changeVehicle');
                elementArray.push('vehicleSelector');
                break;
            case 'sales':
                elementArray.push('selectedVehicle');
                elementArray.push('changeVehicle');
                elementArray.push('vehicleSelector');
                break;
            case 'orders':
                elementArray.push('orderNumber');
                break;
            case 'returns':
                elementArray.push('orderReturn');
                break;
            case 'billing':
                elementArray.push('orderNumber');
                break;
            default:
                break;            
        }
        let loadVehicleSelector = false;
        elementArray.forEach( element => {
            chatJs.render({ element: element, data: chatJs.userData, dest: chatJs.$moreInfo, cb: () => {
                const key = '$' + element;
                delete chatJs[key];
                let jsClass;
                switch ( element ) {
                    case 'vehicleSelector':
                        jsClass = '.js-vehicle-selector';
                        loadVehicleSelector = true;
                        break;
                    case 'selectedVehicle':
                        jsClass = '.js-selected-vehicle';
                        break;
                    case 'changeVehicle':
                        jsClass = '.js-change-vehicle';
                        chatJs.bindEvent({
                            element: $(jsClass),
                            event: 'click',
                            func: chatJs.showVehicleSelector,
                        });
                        break;
                    case 'orderNumber':
                        jsClass = '.js-order-number';
                        break;
                    case 'orderReturn':
                        jsClass = '.js-order-return';
                        break;
                }
                chatJs.registerElement(jsClass);
            }});
        });
        chatJs.createInputList();
        if ( loadVehicleSelector && !chatJs.vehicleSelector ) {

            chatJs.$vehicleSelector.hide();
            chatJs.vehicleSelector = new VehicleSelectorV2(
                chatJs.$vehicleSelector
              , [] // initialize with no selection
            );
            chatJs.vehicleSelector.onVehicleSelected( chatJs.setVehicleData );
            chatJs.vehicleSelector.init(true);

            if (!Boolean(prechatVehicle) ) {
                chatJs.showVehicleSelector();
            }

        }
        if ( !loadVehicleSelector ) {
            chatJs.vehicleSelector = null;
        }
        if ( data == 'other' ) chatJs.validateForm();
    },

    // clear/create manifest of fields to track/validate
    createInputList : ( bypass = false ) => {
        chatJs.formFields = {}; // clear current manifest
        const $inputs = $('input, select, textarea', chatJs.$chatModal).filter('[required]:visible');
        const $inputArray = $.makeArray($inputs);
        $inputArray.forEach( input => {
            const $input = $(input);
            chatJs.formFields[$input.attr('name')] = chatJs.validateInput($input, bypass);
        });
    },

    updateFieldValidState : ( key, isValid ) => {
        chatJs.formFields[key] = isValid;
    },

    updateUserData : $element => {
        const key = $element.attr('name');
        // add custom variable rules here
        switch ( key ) {
            case 'orderNumber':
                orderNumber = $element.val();
            default:
                chatJs.userData[key] = $element.val();
            }
    },

    showVehicleSelector : () => {
        if ( chatJs.$changeVehicle ) chatJs.$changeVehicle.hide();
        if ( chatJs.$selectedVehicle ) chatJs.$selectedVehicle.hide();
        if ( !chatJs.$vehicleSelector ) {
            console.error('chatJs error: cannot show $vehicleSelector');
            return;
        }

        prechatVehicle = null;
        chatJs.$vehicleSelector.show();

        // fix for initializing hidden vehicleSelector clearing userData.vehicle
        chatJs.vehicleSelector.onHasNoSelectedVehicle( () => {
            prechatVehicle = null;
        });
    },

    // check all widget statuses, set UI to 'online' if any are
    getChatStatus : async () => {
        chatJs.isOnline = false;
        await Promise.all(snapEngageWidgets.map( async widget => {
            const statusCheck = await fetch( `https://www.snapengage.com/public/api/v2/chat/${widget.id}`, {
                method: 'GET'
            })
            .then( res => {
                return res.json();
            });
            if (statusCheck.data.online == 'true') chatJs.isOnline = true;
        }));
    },

    beginChat : () => {
        chatJs.setSEUserData( chatJs.userData );
        chatJs.chatOpen = true;
        SnapEngage.startLink();
    },

    // SnapEngage-provided code snippet. DO NOT refactor to ES6+!
    initSEWidget : () => {    
        var se = document.createElement('script'); se.type = 'text/javascript'; se.async = true; se.id = 'seScript';
        se.src = 'https://storage.googleapis.com/code.snapengage.com/js/' + chatJs.activeWidget.id + '.js';
        var done = false;
        se.onload = se.onreadystatechange = function() {
            if (!done&&(!this.readyState||this.readyState==='loaded'||this.readyState==='complete')) {
                done = true;
                chatJs.seEvents();
            }
        };
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
    },

    changeSEWidget : newWidget => {
        let seScript = document.getElementById('seScript');
        seScript.parentNode.removeChild(seScript);
        chatJs.activeWidget = newWidget;
        chatJs.widgetName( newWidget.label );
        sessionStorage.setItem('SEactiveWidgetID', chatJs.activeWidget.id);
        chatJs.initSEWidget();
    },

    // set timer for expired proactive chat, make chat button reappear afterward
    proactiveChat : {
        open : false,
        timer : () => {
            chatJs.proactiveTimer = setTimeout( () => {
                if ( !chatJs.$chatButton.hasClass('show') ) chatJs.$chatButton.addClass('show');
            }, 120000);
        },
        set : () => {
            chatJs.proactiveChat.timer();
            chatJs.proactiveChat.open = true;
        },
        clear : () => {
            clearTimeout( chatJs.proactiveTimer );
            chatJs.proactiveChat.open = false;
        }
    },

    setCookie : ( {name = 'SEchatActive', val = true, timestamp = 900000, clear = false} ) => {
        const d = new Date();
        if (clear) timestamp = -10000; 
        d.setTime( d.getTime() + timestamp );
        const expiresUTC = 'expires=' + d.toUTCString();
        document.cookie = `${name}=${val};${expiresUTC};path=/`;
    },

    // check for a cookie, and optionally its value
    checkCookie : (name = 'SEchatActive', val = false) => {
        if (!val) {
            return Boolean(document.cookie.indexOf(name) !== -1);
        } else {
            const cookiesArray = document.cookie.split(';');
            let SEcookie = false;
            cookiesArray.some( cookie => {
                if (cookie.indexOf(name) !== -1 && cookie.indexOf(val) !== -1) SEcookie = true;
            });
            return SEcookie;
        }
    },

    // make a camel-cased key based on js-prefixed class name
    createKey : classNames => {
        if ( !classNames ) return false;
        const classNameArray = classNames.split(' ');
        let jsClass = false;
        classNameArray.some( className => {
            // isolate the js-prefixed class
            if (className.indexOf('js') !== -1) jsClass = className;
        });
        const substrArray = jsClass.split('-');
        substrArray.shift(); // drop the 'js'
        substrArray.forEach( substr => {
            // capitalize every element after the first
            if (substr != substrArray[0]) {
                const Substr = substr.charAt(0).toUpperCase() + substr.slice(1);
                const index = substrArray.indexOf(substr);
                substrArray[index] = Substr;
            }
        });
        const key = '$' + substrArray.join('');
        return key;
    },

    // add element to chatJs object
    registerElement : ( element, key = false, eventData = false ) => {
        const $element = $(element);
        if ( !key ) key = chatJs.createKey( $element.attr('class') );
        ( chatJs[key] ) ? chatJs[key].push( $element ) : chatJs[key] = $element;
        if ( eventData ) {
            eventData.element = chatJs[key];
            chatJs.bindEvent( eventData );
        }
    },

    // bind events to elements after they are registered in registerElement()
    bindEvent : data => {
        data.element.on( data.event, (data.scope) ? data.scope : null, e => {
            data.func(e);
        });
    },

    applyFocus: () => {
        const $inputs = $('input:visible, select:visible, textarea:visible', chatJs.$chatModal);
        let $firstEmpty;
        $.each( $inputs, ( i, val ) => {
            const $this = $(val);
            if ( !$this.val() ) {
                $firstEmpty = $this;
                return false;
            }
        });
        if ($firstEmpty) $firstEmpty.focus();
    },

    modalEvents : () => {
        chatJs.$chatModal
            .on('show.bs.modal', () => {
                chatJs.$chatButton.removeClass('show');
            })
            .on('shown.bs.modal', () => {
                chatJs.applyFocus();
                chatJs.createInputList(true);
            })
            .on('hide.bs.modal', () => {
                if (!chatJs.chatOpen) chatJs.$chatButton.addClass('show');
            })
            .on('click', '.js-open-chat', () => {
                chatJs.$chatModal.modal('hide');
            })
            .on('input', '.js-user-name, .js-user-email, .js-order-number, .js-first-message', e => {
                chatJs.updateUserData($(e.target));
            })
            .on('input blur', 'input:visible, textarea:visible', e => {
                const $this = $(e.target);
                if ($this.attr('required')) {
                    chatJs.validateInput($this);
                    chatJs.validateForm();
                }
            })
            .on('focus', 'input, select, textarea', e => {
                $(e.target).removeClass('error');
            })
            .on('submit', 'form', e => {
                e.preventDefault();
                chatJs.$chatModal.modal('hide');
                chatJs.beginChat();
            })
            .on('change', 'select', e => {
                let widget = {};
                if ( e.target.value ) {
                    widget = snapEngageWidgets.find( widget => {
                        return widget.value == e.target.value;
                    });
                    chatJs.changeSEWidget(widget);
                }
                chatJs.resetMoreInfo( widget.value );
                chatJs.validateForm();
            });
    },

    initModal : () => {
        chatJs.render({ element: 'modal', data: {user: chatJs.userData, widgets: snapEngageWidgets} });
        chatJs.registerElement('.js-prechat-modal', '$chatModal');
        chatJs.registerElement('.js-user-name');
        chatJs.registerElement('.js-user-email');
        chatJs.registerElement('.js-chat-reason');
        chatJs.registerElement('.js-more-info');
        chatJs.registerElement('.js-open-chat', '$startChatBtn');
        chatJs.modalEvents();
        chatJs.setChatBtnState(false);
    },

    showModal : modal => {
        if (!chatJs.$chatModal) chatJs.initModal();
        chatJs.$chatModal.modal('show');
    },

    render : ( {element, data = chatJs.status, dest = chatJs.$renderTarget, cb = () => {}} ) => {
        const template = Jemplate.process(element, data);
        dest.append(template);
        cb();
    },

    events : () => {
        chatJs.$body.on('click', '.js-begin-chat', e => {
            e.preventDefault();
            if( !chatJs.checkCookie() && !chatJs.chatOpen ) {
                if (chatJs.status.state == 'offline' || chatJs.minimizedChatActive()) {
                    chatJs.beginChat();
                } else {
                    chatJs.showModal(chatJs.$chatModal);
                }
            }
        });
    },

    // events that must be bound/initialized after SnapEngage code initializes
    seEvents : () => {
        SnapEngage.setCallback('Open', () => {
            chatJs.$chatButton.removeClass('show');
        });
        SnapEngage.setCallback('StartChat', () => {
            chatJs.chatOpen = true;
            chatJs.setCookie({});
            if ( chatJs.proactiveChat.open ) chatJs.proactiveChat.clear();
        });
        SnapEngage.setCallback('Close', () => {
            $('span', chatJs.$chatButton).html(`${chatJs.status.labelText} Us`);
            chatJs.$chatButton.addClass('show');
            chatJs.chatOpen = false;
            chatJs.proactiveChat.clear();
            chatJs.setCookie( {clear : true} );
            sessionStorage.removeItem('SEactiveWidgetID');
            document.getElementById('designstudio').remove();
        });
        SnapEngage.setCallback('Minimize', isMinimized => {
            if ( isMinimized ) {
                // Offline chat or normal chat, expired
                if ( !chatJs.proactiveChat.open && (chatJs.status.state == 'offline' || !chatJs.checkCookie()) ) {
                    chatJs.$chatButton.addClass('show');
                    chatJs.chatOpen = false;
                } else {
                    // Proactive chat or normal un-expired chat
                    return;
                }
            } else {
                chatJs.$chatButton.removeClass('show');
            }
        });
        SnapEngage.setCallback('OpenProactive', () => {
            chatJs.$chatButton.removeClass('show');
            chatJs.proactiveChat.set();
        });
        SnapEngage.setCallback('ChatMessageReceived', () => {
            chatJs.setCookie({});
            if ( chatJs.proactiveChat.open ) chatJs.proactiveChat.clear();
        });
        SnapEngage.setCallback('ChatMessageSent', () => {
            chatJs.setCookie({});
            if ( chatJs.proactiveChat.open ) chatJs.proactiveChat.clear();
        });
    },

    init : async () => {
        if ( !chatJs.activeWidget ) {
            chatJs.activeWidget = snapEngageWidgets.find( widget => {
                return widget.testing;
            }) || snapEngageWidgets.find( widget => {
                return widget.default;
            });
        }
        await chatJs.getChatStatus()
        .finally( res => { // .finally() > .then() bc all of this works regardless of Promise resolution
            chatJs.setChatStatus(chatJs.isOnline);
            chatJs.initSEWidget();
            chatJs.getUserData();
            chatJs.render({element: 'button'});
            chatJs.registerElement('.js-floating-chat-btn', '$chatLinks');
            chatJs.registerElement('.js-floating-chat-btn', '$chatButton');
            if ( !chatJs.minimizedChatActive() && !chatJs.checkCookie() ) chatJs.$chatButton.addClass('show');
            chatJs.events();
        });
    }
};

chatJs.init();
